import React, { useEffect } from 'react'
import { IonContent, IonPage, IonSpinner, IonText } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../../components/headerNav/HeaderNav.component'
import { goBack } from '../../../../utilities/navigation.util'
import { getQaAddendumSelector } from '../selectors'
import { fetchChartSummary } from '../store/qaAddendum.actions'
import { toChartSummarySlug } from '../../utils/qaAddendumChartSummary.util'
import ChartSummaryPageDetailContent from '../content/QaAddendumChartSummary/ChartSummaryPageDetail.content'
import QaFlagHeader from '../../components/QaFlagHeader.component'
import { useQAFlagNavigation } from '../../hooks/useQAFlagNavigation.hook'
import './FlagResolution.page.css'

const ChartSummaryPageDetailPage: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { flagId } = useQAFlagNavigation()
  const { pageSlug } = useParams<{ pageSlug: string }>()
  const { chartSummary, isChartSummaryLoading } = useSelector(getQaAddendumSelector)

  useEffect(() => {
    if (flagId && !chartSummary && !isChartSummaryLoading) dispatch(fetchChartSummary(flagId))
  }, [dispatch, flagId, chartSummary, isChartSummaryLoading])

  const pages = (chartSummary?.flatMap((form) => form.pages ?? []) ?? []).filter((page) => page.pageName !== 'Root')
  const page = pages.find((p) => toChartSummarySlug(p.pageName) === pageSlug) ?? null

  return (
    <IonPage id='QaAddendumChartSummaryPageDetail'>
      <QaFlagHeader showMenuButton={false} />
      <HeaderNav
        prevLabel={t('common.buttons.Back')}
        isBackButton
        title={page?.pageName ?? t('qaFlags.qaAddendum.flagResolution.chartSummaryTab')}
        prevOnClick={goBack}
      />
      <IonContent fullscreen color='light'>
        {isChartSummaryLoading && !page ? (
          <IonSpinner className='procedure-loader' data-testid='QaChartSummarySpinner' />
        ) : page ? (
          <ChartSummaryPageDetailContent page={page} />
        ) : (
          <IonText className='qa-addendum-flag-resolution-empty ion-padding' data-testid='QaChartSummaryPageEmpty'>
            {t('qaFlags.qaAddendum.flagResolution.chartSummaryEmpty')}
          </IonText>
        )}
      </IonContent>
    </IonPage>
  )
}

export default ChartSummaryPageDetailPage
